module.exports = __webpack_public_path__ + "static/media/First Abu Dhabi Bank 1.42e21620.jpg";